import React from 'react'
import Banner from './Banner/Banner'
import About from './About/About'
import Contact from './Contact/Contact'
import Footer from '../../shared/Footer'
import ScrollToTop from '../../components/ScrollToTop'
import Navbar from '../../shared/Navbar/Navbar'
import BottomNav from '../../shared/Navbar/BottomNav'
import Portfolio from './Portfolio/Portfolio'
import Services from './Services/Services'
import Skills from './Skills/Skills'

export default function Home() {
  return (
    <>
      <BottomNav />
      <Navbar />
      <Banner />
      <About />
      <Skills />
      <Services />
      <Portfolio />
      <Contact />
      <Footer />
      <ScrollToTop />
    </>
  )
}
